import React from "react";
import clsx from "clsx";

export default function TextInput({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  error = "",
  required = false,
  disabled = false,
  rows = 4,
  className = "",
}) {
  return (
    <div className={clsx("flex flex-col gap-1 w-full", className)}>
      {/* Label */}
      {label && (
        <label
          htmlFor={name}
          className={clsx(
            "text-sm font-medium",
            disabled ? "text-gray-400" : "text-gray-700"
          )}
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      {/* Textarea */}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        className={clsx(
          "px-3 py-2 rounded-lg border text-sm outline-none resize-y transition-colors duration-200",
          disabled
            ? "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed"
            : error
            ? "border-red-400 focus:border-red-500 focus:ring-1 focus:ring-red-200"
            : "border-gray-300 focus:border-[#1E3A5F] focus:ring-1 focus:ring-[#1E3A5F]/20"
        )}
      />

      {/* Error */}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
}
